import { combineReducers } from 'redux'

import { reducer as timesheetPostingModal } from './State/timesheetPostingModal'
import { reducer as projectSubcontractors } from './State/projectSubcontractors'

export default combineReducers({
  timesheetPostingModal,
  projectSubcontractors,
})
